export const treeTableTheme = {
  header: {
    padding: 'var(--rem) var(--rem)',
    borderWidth: '1px 0 1px var(--reset)',
  },
  headerCell: {
    padding: 'var(--rem) var(--rem)',
  },
  columnTitle: {
    fontWeight: '500',
  },
  bodyCell: {
    padding: 'var(--half-rem) var(--half-rem)',
  },
  footer: {
    padding: 'var(--rem) var(--rem)',
  },
  colorScheme: {
    light: {
      header: {
        color: 'var(--text-color)',
        borderColor: 'var(--p-primary-600)',
      },
      headerCell: {
        background: 'var(--p-surface-100)',
        color: 'var(--text-color)',
        borderColor: 'var(--p-primary-600)',
      },
      row: {
        color: 'var(--text-color)',
      },
      footer: {
        background: 'var(--p-surface-300)',
        color: 'var(--text-color)',
        borderColor: 'var(--p-primary-600)',
      },
    },
    dark: {
      header: {
        color: 'var(--text-color)',
        borderColor: 'var(--p-primary-600)',
      },
      headerCell: {
        background: 'var(--p-surface-700)',
        color: 'var(--text-color)',
        borderColor: 'var(--p-primary-900)',
      },
      row: {
        color: 'var(--text-color)',
      },
      footer: {
        background: 'var(--p-surface-700)',
        color: 'var(--text-color)',
        borderColor: 'var(--p-primary-900)',
      },
    },
  },
  css: ({ dt }: any) => `
  p-treetable p-treetabletoggler {
    margin-right: var(--half-rem);
  }
  `,
};
